export default {"src":"/_next/static/media/LCID.3e9b538b.svg","height":18,"width":18};